export default "__VITE_ASSET__CBuVWqnc__"